import { NotificationSetModalService } from '@modules/notification-management/modals/notification-set-modal/notification-set-modal.service';
import { INotificationPayload } from '@modules/notification-management/interfaces/notifications.interface';
import { BaseModalComponent } from '@app/components/modals/base/base-modal.component';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-notification-set-modal',
	templateUrl: './notification-set-modal.component.html',
	styleUrls: ['./notification-set-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [NotificationSetModalService],
})
export class NotificationSetModalComponent extends BaseModalComponent {
	public readonly channels$: Observable<string[]> = this.service.getSlackChannels().pipe(map((x) => x.channels));
	public readonly hasSlack$: Observable<boolean> = this.service.hasSlack();
	public readonly hasTeams$: Observable<boolean> = this.service.hasTeams();
	public readonly setNames: string[] = this.service.getSetNames();

	public isSubmitting: boolean = false;

	protected _title = 'Notification Setting Creation';

	private _orgId: number;

	constructor(public service: NotificationSetModalService) {
		super();
	}

	public setup(orgId: number): void {
		this._orgId = orgId;
	}

	public close(): void {
		this._hideFunc();
	}

	public save($event: Pick<INotificationPayload, 'subscriptions' | 'targets' | 'name'>): void {
		const payload: INotificationPayload = {
			org_id: this._orgId,
			active: true,
			...$event,
		};
		this.isSubmitting = true;
		this.service
			.create(payload)
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(() => {
				this._hideFunc();
				this.isSubmitting = false;
			});
	}
}
